// Wallet Service
import { isMockMode } from '../config/api.config';
import { getMockTransactions } from '../data/mock/transactions.mock';
import { apiService } from './api';

export interface Transaction {
  id: string;
  type: 'deposit' | 'withdrawal' | 'payment' | 'refund';
  amount: number;
  description: string;
  date: string;
  status: 'completed' | 'pending' | 'failed';
}

export interface WalletBalance {
  total: number;
  available: number;
  blocked: number;
}

class WalletService {
  async getBalance(): Promise<WalletBalance> {
    if (isMockMode()) {
      return { total: 2450000, available: 2450000, blocked: 0 };
    }

    try {
      const response = await apiService.api.get('/wallet/balance');
      return response.data;
    } catch {
      return { total: 2450000, available: 2450000, blocked: 0 };
    }
  }

  async getTransactions(): Promise<Transaction[]> {
    if (isMockMode()) {
      return getMockTransactions();
    }
    
    try {
      // TODO: Uncomment when wallet API is ready
      // const response = await apiService.api.get('/wallet/transactions');
      // return response.data;
      
      return getMockTransactions();
    } catch (error) {
      console.error('Failed to fetch transactions:', error);
      return getMockTransactions();
    }
  }

  async deposit(amount: number): Promise<Transaction> {
    const tx: Transaction = {
      id: `tx-${Date.now()}`,
      type: 'deposit',
      amount,
      description: 'شارژ کیف پول',
      date: new Date().toISOString(),
      status: 'completed',
    };
    if (!isMockMode()) {
      try {
        await apiService.api.post('/wallet/deposit', { amount });
      } catch {
        // fallback mock
      }
    }
    return tx;
  }

  async withdraw(amount: number): Promise<Transaction> {
    const tx: Transaction = {
      id: `tx-${Date.now()}`,
      type: 'withdrawal',
      amount,
      description: 'برداشت از کیف پول',
      date: new Date().toISOString(),
      status: 'completed',
    };
    if (!isMockMode()) {
      try {
        await apiService.api.post('/wallet/withdraw', { amount });
      } catch {
        // fallback mock
      }
    }
    return tx;
  }
}

export const walletService = new WalletService();

